"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.callParentAndChildMethod = void 0;
/**
 * Call the method defined on the parent, then call the method on the child.
 * @param parent Parent on whom call the method
 * @param child Child on whom call the method
 * @param methodName Name of the method to call
 * @returns A function calling the method defined in the Parent then call the method defined in Child.
 */
exports.callParentAndChildMethod = function (parent, child, methodName) { return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    parent && methodName && parent[methodName]
        ? parent[methodName].apply(parent, __spread(args)) : null;
    child && methodName && child[methodName] ? child[methodName].apply(child, __spread(args)) : null;
}; };
